<template>
  <div class="tooltip">
    <slot name="item"></slot>
    <slot name="tooltip"></slot>
  </div>
</template>

<script setup lang="ts">

</script>

<style scoped lang="scss">

</style>
